/**
 * Email Verification Banner
 * Shows a dismissible banner when user's email is not verified
 */

import React, { useState } from 'react';
import { sendVerificationEmail } from '../../services/authService';

interface EmailVerificationBannerProps {
  email: string;
}

const EmailVerificationBanner: React.FC<EmailVerificationBannerProps> = ({ email }) => {
  const [isDismissed, setIsDismissed] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [message, setMessage] = useState<{ type: 'success' | 'error'; text: string } | null>(null);

  const handleResend = async () => {
    setIsSending(true);
    setMessage(null);

    try {
      await sendVerificationEmail();
      setMessage({ type: 'success', text: '驗證信已發送！請檢查您的信箱。' });
    } catch (error) {
      setMessage({ type: 'error', text: '發送失敗，請稍後再試。' });
    } finally {
      setIsSending(false);
    }
  };

  if (isDismissed) {
    return null;
  }

  return (
    <div className="email-verification-banner">
      <div className="email-verification-banner-content">
        <span className="email-verification-banner-icon">📧</span>
        <span className="email-verification-banner-text">
          請驗證您的 Email ({email}) 以解鎖完整功能
        </span>
        {message ? (
          <span className={`email-verification-banner-message ${message.type}`}>
            {message.text}
          </span>
        ) : (
          <button
            className="email-verification-banner-resend"
            onClick={handleResend}
            disabled={isSending}
          >
            {isSending ? '發送中...' : '重新發送'}
          </button>
        )}
      </div>
      <button
        className="email-verification-banner-dismiss"
        onClick={() => setIsDismissed(true)}
        aria-label="關閉提示"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  );
};

export default EmailVerificationBanner;
